"use strict";

var Backbone                            = require("backbone");
var _                                   = require("underscore");
var $                                   = require("jquery");
Backbone.$ = $;

var debug                               = require("debug")("views:OverlayBlocksView");

/**
 * Retronews PageSemanticView: overlay view displaying text blocks from ocr
 * Trigger:
 * - "click:block":
 */
module.exports=Backbone.View.extend({

    model:null,         // RetronewsPageSemanticModel
    className:"overlay overlay-blocks",
    events:{
        "pointerdown .block":"onPointerDown",
        "pointerup .block":"onPointerUp"
    },

    initialize:function(options){
        var T=this;
        _.extend(T, options);
        T._pageX=0;
        T._pageY=0;
        if(T.hide){
            T.$el.addClass("hide");
        }
        T.listenTo(T.model,"sync",T.render);
        T.render();
    },

    render:function(){
        var T=this;

        T.$el.html("");
        if(T.model.fetched){
            debug("render blocks page "+T.page);
            var blocks=T.model.get("blocks"),
                width=T.model.get("width"),
                height=T.model.get("height");

            if(blocks){
                _.each(blocks,function(block){
                     var $div=$("<div/>",{
                        class:"block",
                        id:block.id
                    });
                    $div.css({
                        top:(block.vpos*100/height)+"%",
                        left:(block.hpos*100/width)+"%",
                        height:(block.height*100/height)+"%",
                        width:(block.width*100/width)+"%"
                    });
                    T.$el.append($div);
                });
            }
        }
    },

    onPointerDown:function(e){
        var T=this;
        T._pageX=e.pageX;
        T._pageY=e.pageY;
    },

    onPointerUp:function(e){
        var T=this,
            distance=Math.sqrt(Math.pow(T._pageX-e.pageX, 2) + Math.pow(T._pageY-e.pageY, 2));

        if(distance<4){
            T.trigger("click:block",T,e.target.id);
        }
    },

    close:function(){
        var T=this;
        T.stopListening();
        T.undelegateEvents();
    }
});